<template>
    <v-container fluid class="gallery-container">
        <!-- Toggle between Table View and ID Card View -->
        <v-row justify="end" class="mb-4">
            <RouterLink to="/cardSample">
                <BaseButton color="primary" outlined>
                    My ID Card
                </BaseButton>
            </RouterLink>
            <!-- <BaseButton v-if="!showCardView" color="primary" outlined @click="showIDCardView" class="mr-4">
                My ID Card
            </BaseButton> -->
            <!-- <BaseButton v-if="showCardView" color="primary" outlined @click="backToTable" class="mr-4">
                Back to Table
            </BaseButton>
             <BaseButton v-if="showCardView" color="primary" outlined @click="openModal">
                + Choose My Card
             </BaseButton> -->



        </v-row>
        <StudentEmploee v-if="!showCardView" @studentType="handleChooseCard" />

        <!-- Table View (default) -->
        <!-- <v-card v-if="!showCardView" flat class="mb-4"> -->
        <v-card flat class="mb-4">
            <v-card-title class="d-flex justify-space-between align-center">
                <div v-if="userType === 'student'">
                    <span>Class Section</span>
                    <!-- You can add more elements here for students -->
                </div>

                <div v-else>
                    <span>Employee Department</span>
                    <!-- Add more elements here for non-students -->
                </div>

                <!-- <RouterLink to="/cardSample"> -->
                <!-- <BaseButton  :disabled="!classSearched || loading"  color="primary" outlined @click="printIDCard">
                    Prints
                </BaseButton> -->
                <BaseButton :disabled="(userType === 'student' && !classSearched || loading)" color="primary" outlined
                    @click="printIDCard">
                    Prints
                </BaseButton>
                <!-- </RouterLink> -->
            </v-card-title>
            <v-card-text v-if="userType === 'student'">
                <v-row class="px-4 align-center">
                    <v-col cols="6" md="4">
                        <v-select v-model="selectedClass" :items="classes" label="Select Class" outlined dense
                            item-value="id" item-title="name" color="primary"></v-select>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" class="ml-2" dense @click="searchClass">
                            Search
                        </v-btn>
                    </v-col>
                </v-row>

            </v-card-text>
            <v-data-table v-if="!loading" v-model="selectedStudentRowPrint" id="dataTable" :items-per-page="-1" hide-default-footer
                :headers="userType === 'student' ? headers : employeeHeaders"
                :items="userType === 'student' ? fetchedStudents : employees" :search="search" item-value="id"
                show-select class="elevation-1 mt-4 data-list-table" dense>
                <template v-slot:[`item.name`]="{ item }">
                    <v-row align="center" no-gutters>
                        <v-col class="d-flex align-center pa-2" :cols="3">
                            <v-img :src="item.image || noImage" class="student-image mrr-10" alt="Student Image" />
                            <span>{{ item.name }}</span> <br />
                            <!-- <span>'{{ item.id }}'</span> -->
                        </v-col>
                    </v-row>
                </template>


                <template v-slot:item.birth_date="{ item }">
                    <span>{{ formatDate(item.birth_date) }}</span>
                </template>

                <template v-slot:footer="{ props }">
                    <v-row class="align-center">
                        <v-col cols="auto">
                            <span class="footer-text">Total
                                {{ userType === "student" ? "Students" : "Employees" }}:</span>
                        </v-col>
                        <v-col cols="auto">
                            <v-data-table-footer :props="props" class="d-flex justify-start align-center" />
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </v-card>

    </v-container>


    <div v-html="previewImage" />


</template>

<script setup>
import Swal from "sweetalert2";
import { useCardStore } from "@/Store/cardStore";
import { ref, onMounted, computed, watch, nextTick } from "vue";
import { apiConfig } from "@/config/apiConfig";
import BaseButton from "@/components/Apps/cardSample/BaseButton.vue";
import StudentEmploee from "@/components/Apps/cardSample/StudentEmploee.vue";
import cardSample from "@/components/Apps/cardSample/CardSample.vue";
import { getEmployee } from "@/services/apiServices";

import {
    sample,
    previewCard,
    classNames,
    getAssignedCard,
    postSampleCards,
    schoolDetail,
    studentLists,
} from "@/services/apiServices";
import banner1 from "@/assets/images/administrator.jpg";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import Papa from "papaparse";
import noImage from "@/assets/images/image_not_available-removebg-preview (1).png"
import { useRouter } from "vue-router"; // Import Vue Router for programmatic navigation
const router = useRouter(); // Initialize the router instance

// Data properties
const cards = ref([]);
const loading = ref(false);
const error = ref("");
const showDialog = ref(false);
const selectedCard = ref(null);
const type = ref(null);
const classsInfoList = ref([]);
const chosenCard = ref([]);
const schoolId = ref();
const schoolInfoList = ref({});
const filteredClasses = ref([]);
const userType = ref("student");
const search = ref("");
const currentClassSection = ref("All Classes");
const showCardView = ref(false);
const selectedCardDesign = ref(null);
const selectedStudents = ref([]);
// Table View Data
const selectedClass = ref(null);
const selectedCardPages = ref(null);
const classes = ref([]);
const fetchedStudents = ref([]);
const employees = ref([]);
const showPreviewCard = ref(false);
const afterPreviewCard = ref(false);
const classSearched = ref(false);
const selectedStudentRowPrint = ref([]);
const cardStore = useCardStore();


const itemsPerPage = ref(10);
const computedItemsPerPage = computed(() => {
    return itemsPerPage.value === 'All' ? -1 : Number(itemsPerPage.value)
});

const headers = ref([
    { align: "start", key: "roll_no", sortable: true, title: "ROLL" },
    { key: "name", sortable: true, title: "NAME" },
    { key: "birth_date", sortable: true, title: "DOB" },
    { key: "gender", sortable: true, title: "GENDER" },
    { key: "parent_name", sortable: true, title: "Parent's Name" },
    { key: "contact", sortable: true, title: "CONTACT" },
    // { key: "actions", sortable: false, title: "ACTION" },
]);


const employeeHeaders = ref([
    { align: "start", key: "employee_id", sortable: true, title: "EMP ID" },
    { key: "name", sortable: true, title: "Name" },
    { key: "birth_date", sortable: true, title: "DOB" },
    { key: "gender", sortable: true, title: "Gender" },
    { key: "designation", sortable: true, title: "Designation" },
    { key: "contact", sortable: true, title: "Contact" },
    // { key: "actions", sortable: false, title: "ACTION" },
]);


watch(selectedClass, () => {
    classSearched.value = false;
});



// const getImage = (items) => {
//     return items ? `${apiConfig.imageUrl}/${items}` : banner1;
// };

// import { getCurrentInstance } from 'vue';
// const { appContext } = getCurrentInstance();
// const getImage = appContext.config.globalProperties.$getImage;

const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString();
};

const showIDCardView = () => {
    showCardView.value = true;
};

const backToTable = () => {
    showCardView.value = false;
};

const fetchSchool = async () => {
    try {
        const data = await schoolDetail();
        schoolInfoList.value = data;
        schoolId.value = Array.isArray(data)
            ? data.map((school) => school.id)
            : [data.id];
    } catch (err) {
        console.error("Failed to load school details:", err);
    }
};

const fetchClasss = async () => {
    try {
        const data = await classNames();
        // console.log("Class data:", data);
        classsInfoList.value = data;
        classes.value = data; // For table view class selection
    } catch (err) {
        error.value = err.response?.data?.message || "Failed to load classes";
        console.error("Error fetching class details:", err);
    }
};

const searchClass = async () => {
    if (!selectedClass.value) {
        Swal.fire("Please select a class");
        return;
    }
    try {
        const response = await studentLists(selectedClass.value);
        if (response) {
            fetchedStudents.value = response;
            classSearched.value = true;
        } else {
            console.warn("No data returned from the API");
        }
    } catch (error) {
        console.error("Error fetching students:", error);
    } finally {
        loading.value = false; // Hide loader
    }
};


const fetchEmployees = async () => {
    try {
        const response = await getEmployee();
        employees.value = response || [];
        // console.log("Employee data:", employees.value);
    } catch (error) {
        console.error("Error fetching employees:", error);
    }
};


const fetchSampleCards = async (cardType) => {
    loading.value = true;
    try {
        const data = await sample(cardType);
        cards.value = data;
        type.value = cardType;
    } catch (err) {
        error.value = err.response?.data?.message || "Failed to load cards";
        console.error("Error fetching sample cards:", err);
    } finally {
        loading.value = false;
    }
};

const openModal = async () => {
    selectedCard.value = null;
    classsInfoList.value = [];
    filteredClasses.value = [...classsInfoList.value];
    await fetchClasss();
    showDialog.value = true;
};

const fetchAssignedCards = async (cardType) => {
    loading.value = true;
    try {
        const data = await getAssignedCard(cardType);
        chosenCard.value = data.choosen_cards.map((card) => ({
            ...card,
            class_info_names: card.class_info.map((classId) => {
                const match = classsInfoList.value.find((info) => info.id === classId);
                return match ? match.name : null;
            }),
        }));

        currentClassSection.value = chosenCard.value.length
            ? chosenCard.value[0].class_info_names?.join(", ") || "All Classes"
            : "All Classes";

        if (chosenCard.value.length > 0) {
            selectedCardDesign.value = chosenCard.value[0].card;
        }
    } catch (err) {
        error.value =
            err.response?.data?.message || "Failed to load assigned cards";
        console.error("Error fetching assigned cards:", err);
    } finally {
        loading.value = false;
    }
};

let hasPrinted = false;

// const printIDCard = async () => {
//     if (hasPrinted) return;
//     hasPrinted = true;


//     loading.value = true;
//     showPreviewCard.value = false;
//     error.value = "";


//     try {
//         console.log("Printing ID card...");
//         let data;


//         if (userType.value === 'student') {
//             if (!selectedClass.value) {
//                 error.value = "Please select a class for student ID cards.";
//                 loading.value = false;
//                 hasPrinted = false; // Reset here since it's an early return
//                 return;
//             }
//             data = await previewCard(selectedClass.value, userType.value);
//         } else {
//             data = await previewCard(null, userType.value);
//         }


//         console.log("selected card type", userType.value);
//         // handle data here


//     } catch (err) {
//         console.error("Full error:", err); // Add this line for full insight
//     const errMsg = err.response?.data?.message || "Failed to load cards";
//     error.value = errMsg;


//         Swal.fire({
//             icon: "error",
//             title: "Error",
//             text: errMsg,
//             toast: true,
//             position: "top-end",
//             showConfirmButton: false,
//             timer: 3000,
//             timerProgressBar: true,
//         });


//     } finally {
//         loading.value = false;
//         setTimeout(() => {
//             hasPrinted = false;
//         }, 3000);
//     }
// };

import html2canvas from "html2canvas";
const previewImage = ref();



const printIDCard = async () => {
    // console.log("selectedStudentRowPrint", selectedStudentRowPrint)
    if (hasPrinted) return;
    hasPrinted = true;
    loading.value = true;
    error.value = "";
    try {
        let data;
        if (userType.value === 'student') {
            data = await previewCard(selectedClass.value, userType.value, selectedStudentRowPrint.value);
            // console.log("data", data)
        } else {
            data = await previewCard(null, userType.value, selectedStudentRowPrint.value);
        }
        const printWindow = window.open("", "_blank");
        if (!printWindow) {
            alert("Popup blocked. Please allow popups for this site.");
            return;
        }
        const extraFooter = ''
        //     const extraFooter = `<div id="printBtn" style="">
        // <button class="btn btn-primary" onclick="window.print()">Print</button>
        //     </div>`

        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');
        doc.body.innerHTML += extraFooter;
        doc.head.innerHTML += `
        <style>
        #printBtn {
         position: absolute;
          top: 20px; 
          right: 25px; 
          }
        @media print {
      #printBtn {
        display: none !important;
      }
    }
        </style>`;

        printWindow.document.open();
        printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>${doc.head.innerHTML}</head>
        <body>${doc.body.innerHTML}</body>
      </html>
    `);
        printWindow.document.close();
        selectedStudentRowPrint.value = [];
    } catch (err) {
        console.error("Error:", err);

        const errorMessage = err.response?.data?.message || err.message || "Something went wrong";

        // await Swal.fire({
        //     icon: 'error',
        //     title: 'Error',
        //     text: errorMessage,
        // });

        error.value = errorMessage;

    } finally {
        loading.value = false;
        setTimeout(() => {
            hasPrinted = false;
        }, 3000);
    }
};

// here is for selected individual rows
// const printIDCard = async () => {
//   console.log("Selected for print:", selectedStudentRowPrint);
//   if (hasPrinted) return;
//   hasPrinted = true;
//   loading.value = true;
//   error.value = "";

//   try {
//     let data;
//     const selectedIds = selectedStudentRowPrint.map(item => item.id);

//     if (selectedIds.length === 0) {
//       alert("Please select at least one record to print.");
//       hasPrinted = false;
//       loading.value = false;
//       return;
//     }

//     if (userType.value === 'student') {
//       data = await previewCard(selectedClass.value, userType.value, selectedIds);
//     } else {
//       data = await previewCard(null, userType.value, selectedIds);
//     }

//     const printWindow = window.open("", "_blank");
//     if (!printWindow) {
//       alert("Popup blocked. Please allow popups for this site.");
//       return;
//     }

//     const extraFooter = '';
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(data, 'text/html');
//     doc.body.innerHTML += extraFooter;
//     doc.head.innerHTML += `
//       <style>
//         #printBtn {
//           position: absolute;
//           top: 20px;
//           right: 25px;
//         }
//         @media print {
//           #printBtn {
//             display: none !important;
//           }
//         }
//       </style>
//     `;

//     printWindow.document.open();
//     printWindow.document.write(`
//       <!DOCTYPE html>
//       <html>
//         <head>${doc.head.innerHTML}</head>
//         <body>${doc.body.innerHTML}</body>
//       </html>
//     `);
//     printWindow.document.close();

//   } catch (err) {
//     console.error("Error:", err);
//     error.value = err.response?.data?.message || err.message || "Something went wrong";
//   } finally {
//     loading.value = false;
//     setTimeout(() => {
//       hasPrinted = false;
//     }, 3000);
//   }
// };


// const downloadCard = async () => {
//     window.print()
//     try {
//         const iframeDoc = iframeRef.value?.contentDocument;
//         if (!iframeDoc) {
//             error.value = "Iframe not found or not loaded.";
//             return;
//         }

//         const element = iframeDoc.getElementById("idCardPreview");
//         if (!element) {
//             error.value = "ID Card element not found.";
//             return;
//         }

//         // Use html2canvas to take snapshot
//         const canvas = await html2canvas(element, { useCORS: true });
//         const imgData = canvas.toDataURL("image/png");

//         // Trigger download
//         const link = document.createElement("a");
//         link.href = imgData;
//         link.download = "id_card.png";
//         link.click();
//     } catch (err) {
//         console.error("Download error:", err);
//         error.value = "Failed to download the ID card.";
//     }
// };


// const printIDCard = async () => {
//   if (hasPrinted) return;
//   hasPrinted = true;

//   loading.value = true;
//   error.value = "";

//   try {
//     let data;

//     if (userType.value === 'student') {
//       if (!selectedClass.value) {
//         error.value = "Please select a class for student ID cards.";
//         loading.value = false;
//         hasPrinted = false;
//         return;
//       }
//       data = await previewCard(selectedClass.value, userType.value);
//     } else {
//       data = await previewCard(null, userType.value);
//     }

//     const extraFooter = `
//       <div style="text-align: center; margin-top: 20px;">
//         <small>Printed on: ${new Date().toLocaleDateString()}</small>
//       </div>
//     `;

//     const parser = new DOMParser();
//     const doc = parser.parseFromString(data, 'text/html');
//     doc.body.innerHTML += extraFooter;

//     // Save content to sessionStorage and navigate
//     sessionStorage.setItem('printData', `
//       <!DOCTYPE html>
//       <html>
//         <head>${doc.head.innerHTML}</head>
//         <body>${doc.body.innerHTML}</body>
//       </html>
//     `);

//     router.push('/print-id-card');

//   } catch (err) {
//     console.error("Error:", err);
//     error.value = err.message || "Something went wrong";
//   } finally {
//     loading.value = false;
//     setTimeout(() => {
//       hasPrinted = false;
//     }, 3000);
//   }
// };




const submitSelection = async () => {
    const updatedData = { ...classsInfoList.value };
    error.value = null;
    loading.value = true;
    try {
        if (!selectedCard.value) {
            error.value = "Please select a card";
            return;
        }
        const formData = new FormData();
        formData.append("card", selectedCard.value.id);
        if (type.value === "student") {
            if (Array.isArray(updatedData.class_info)) {
                updatedData.class_info.forEach((classItem) => {
                    if (typeof classItem === "number") {
                        formData.append("class_info[]", classItem);
                    }
                });
            } else {
                formData.append("class_info", updatedData.class_info.id);
            }
        }
        formData.append("school", schoolInfoList.value.id);
        await postSampleCards(formData);

        showDialog.value = false;
        await fetchAssignedCards(type.value);

        Swal.fire({
            icon: "success",
            title: "Card chosen successfully",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });
    } catch (err) {
        error.value =
            err.response?.data?.message || "Failed to submit card selection";
        console.error("Error submitting selection:", err);
    } finally {
        loading.value = false;
    }
};

const handleChooseCard = async (cardType) => {
    userType.value = cardType;
    await fetchAssignedCards(cardType);
};

// Lifecycle hooks
onMounted(async () => {
    await fetchSchool();
    await fetchClasss();
    await handleChooseCard("student");
    await fetchSampleCards("student");
    await fetchEmployees();
    error.value = "";
});
</script>

<style scoped>
.html-wrapper {
    all: initial;
    /* Reset all inherited styles */
    display: block;
}

/* Optionally re-enable what you need */
.html-wrapper * {
    all: unset;
    display: revert;
}

.gallery-container {
    padding: 16px;
}

.headline {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    background-color: #f8f8f8;
    padding: 0.8rem 1.4rem;
    border-bottom: 0 solid #ebe9f1;
    border-top-left-radius: 0.357rem;
    border-top-right-radius: 0.357rem;
}

.modal-title {
    font-size: 1.3rem;
    margin-bottom: 0;
    line-height: 1.45;
}

.square-btn {
    width: 40px;
    height: 40px;
    background-color: rgb(221, 198, 245);
}

.scrollable-div::-webkit-scrollbar {
    width: 5px;
    height: 23px;
}

.scrollable-div::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.scrollable-div::-webkit-scrollbar-thumb {
    background: #c4c3fa;
    border-radius: 10px;
}

.angle-card-imgs {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.text-danger {
    color: red;
}

.student-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
}

.mrr-10 {
    margin-right: 10px;
}

.footer-text {
    font-weight: bold;
}

/* Print styles */
@media print {

    .v-btn,
    .v-card-actions {
        display: none !important;
    }

    .v-data-table {
        width: 100% !important;
    }

    .v-data-table th,
    .v-data-table td {
        border: 1px solid #ddd;
        padding: 8px;
    }

    .v-data-table th {
        background-color: #f2f2f2;
    }
}

/* Card selection styles */
.v-card {
    transition: transform 0.2s;
    cursor: pointer;
}

.v-card:hover {
    transform: scale(1.03);
}

.selected-card {
    border: 2px solid var(--v-primary-base);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>